import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";

import {
  Container,
  Typography,
  TextField,
  Box,
  Divider,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InfoIcon from "@mui/icons-material/Info";

import { LoadingButton } from "@mui/lab";

import bgImage from "./images/lawa_logo.png";

import abmlogo from "./images/abmlogo.png";

import SuccessScreen from "./SuccessScreen";
import { api, envType, headers } from "./exports";
import { Label } from "@mui/icons-material";

const MAX_TRIES = 1;
const WAIT_TIME = 3;
const TRIES_EXCEEDED_MSG = `You exceeded the number of tries!!! Please refresh after `;

const RootStyle = styled("div")({
  background: "white",
  display: "grid",
  placeItems: "center",
  alignContent: "center",
});

const HeadingStyle = styled(Box)({
  textAlign: "center",
});

const ContentStyle = styled("div")({
  maxWidth: 450,
  padding: 25,
  margin: "auto",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  backgroundRepeat: "no-repeat",
});

const MessageContentStyle = styled("div")({
  maxWidth: 450,
  height: "50vh",
  padding: 25,
  margin: "auto",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
});

const LogoStyle = styled("div")({
  maxWidth: 450,
  margin: "auto",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  backgroundRepeat: "no-repeat",
});

const labelStyles = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "black", // Default border color
    },
    "&:hover fieldset": {
      borderColor: "black", // Border color on hover
    },
    "&.Mui-focused fieldset": {
      borderColor: "#0545af", // Border color when focused
    },
  },
};

function App() {
  const [isSubmitting] = useState(false);
  const [ticketType, setTicketType] = useState("");
  const [ticketValue, setTicketValue] = useState("");
  const [ticketLPN, setTicketLPN] = useState("");

  const [ticketTypeError, setTicketTypeError] = useState(false);
  const [ticketValueError, setTicketValueError] = useState(false);
  const [ticketLPNError, setTicketLPNError] = useState(false);

  const [loading, setLoading] = useState(false);
  const [inactive, setInactive] = useState(false);
  const [success, setSuccess] = useState(false);

  const [errorMessageOpen, setErrorMessageOpen] = React.useState(false);
  const [errorMessageString, setErrorMessageString] = React.useState("");
  const [qrstatus, setQrStatus] = React.useState({
    health: null,
    status: null,
    status_message: null,
    current_evse_state: null,
  });
  const [isLoading, setIsLoading] = React.useState(false);

  const queryParameters = new URLSearchParams(window.location.search);
  const unitId = queryParameters.get("unit_id")?.toUpperCase();

  const [lpn, setLpn] = useState(0);
  const [ticket, setTicket] = useState(0);
  const [bookingReference, setBookingReference] = useState(0);

  const [withinTheRadius, setWithinTheRadius] = useState(false);

  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [isLocationLoading, setIsLocationLoading] = useState(true);

  console.log(unitId);

  useEffect(() => {
    if (envType === "prod") {
      if (!longitude || !latitude || !withinTheRadius || !unitId) return;
    }
    setIsLoading(true);
    fetch(`${api}/operations/ev/qrvalidation?unitid=${unitId}`, {
      method: "GET",
      headers: headers,
    })
      .then((res) => res.json())
      .then(({ data }) => setQrStatus(data))
      .finally(() => setIsLoading(false));
  }, []);

  // console.log(!longitude, !latitude, !withinTheRadius, !unitId);

  // const [timeDiff, setTimeDiff] = useState(0);

  // useEffect(() => {
  //   console.log("JI");
  //   if (
  //     localStorage.getItem("timestamp") === null ||
  //     localStorage.getItem("lpn") === null ||
  //     localStorage.getItem("ticket") === null ||
  //     localStorage.getItem("booking-reference") === null
  //   ) {
  //     resetForm();
  //   } else {
  //     const tempTimestamp = parseInt(localStorage.getItem("timestamp"));
  //     const tempLpn = parseInt(localStorage.getItem("lpn"));
  //     const tempTicket = parseInt(localStorage.getItem("ticket"));
  //     const tempBookingRef = parseInt(
  //       localStorage.getItem("booking-reference")
  //     );

  //     if (calculateTimeElapsed(tempTimestamp) >= WAIT_TIME) {
  //       resetForm();
  //     } else {
  //       const tempTimeDiff = WAIT_TIME - calculateTimeElapsed(tempTimestamp);
  //       setLpn(tempLpn);
  //       setTicket(tempTicket);
  //       setBookingReference(tempBookingRef);
  //       setTimer(tempTimeDiff);
  //       setTimeDiff(tempTimeDiff);
  //       if (tempBookingRef + tempLpn + tempTicket >= MAX_TRIES * 3) {
  //         setInactive(true);
  //       }
  //     }
  //   }
  // }, []);

  // console.log(latitude, longitude);

  const fixedLatitude = 33.9422;
  const fixedLongitude = -118.4036;
  const radiusInMiles = 30;

  // Function to calculate distance between two points using the Haversine formula
  function getDistanceFromLatLonInMiles(lat1, lon1, lat2, lon2) {
    const R = 3958.8; // Radius of the Earth in miles
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in miles
    return d;
  }

  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  // Function to check if user is within the radius
  function isWithinRadius(latitude, longitude) {
    const distance = getDistanceFromLatLonInMiles(
      fixedLatitude,
      fixedLongitude,
      latitude,
      longitude
    );
    if (distance <= radiusInMiles) {
      console.log("Within the radius.");
      setWithinTheRadius(true);
    } else {
      console.log("Outside the radius.");
      setWithinTheRadius(false);
    }
    return distance <= radiusInMiles;
  }

  //Check user's location and take action
  // navigator.geolocation?.getCurrentPosition(
  //   (position) => {
  //     setLatitude(position.coords.latitude);
  //     setLongitude(position.coords.longitude);
  //     isWithinRadius(position.coords.latitude, position.coords.longitude);
  //     // if (!isWithinRadius(latitude, longitude)) {
  //     //   if (!localStorage.getItem("pageReloaded")) {
  //     //     localStorage.setItem("pageReloaded", "true");
  //     //     //reloadAndShowMessage();
  //     //   }
  //     // } else {
  //     //   localStorage.removeItem("pageReloaded");
  //     // }
  //   },
  //   (error) => {
  //     console.error("Error getting user's location:", error);
  //     setLatitude(null);
  //     setLongitude(null);
  //   }
  // );

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
          isWithinRadius(position.coords.latitude, position.coords.longitude);
          setIsLocationLoading(false); // Done loading
        },
        (error) => {
          console.error("Error getting user's location:", error);
          setLatitude(null);
          setLongitude(null);
          setIsLocationLoading(false); // Done loading even on error
        }
      );
    } else {
      setIsLocationLoading(false);
    }
  }, []);

  useEffect(() => {
    if (ticketType !== "lpn") {
      setTicketLPN("");
    }
    setTicketValueError(false);
    setTicketLPNError(false);
  }, [ticketType]);

  function setTimer(value) {
    setTimeout(() => resetForm(), 60000 * value);
  }

  function calculateTimeElapsed(tOld) {
    let tNow = Date.now();
    let diffMs = tNow - tOld;
    let minDiff = Math.round(((diffMs % 86400000) % 3600000) / 60000);
    return minDiff;
  }

  function resetForm() {
    console.log("Bye");
    setLpn(0);
    // localStorage.setItem("lpn", 0);
    setTicket(0);
    // localStorage.setItem("ticket", 0);
    setBookingReference(0);
    // localStorage.setItem("booking-reference", 0);
    // localStorage.setItem("timestamp", Date.now());
    setInactive(false);
    setTimer(WAIT_TIME);
  }

  const handleErrorMessage = (event) => {
    setErrorMessageOpen(false);
    setTicketTypeError(false);
    setTicketValueError(false);
    setTicketLPNError(false);
    setTicketType("");
    setTicketValue("");
    setTicketLPN("");
  };

  // console.log(api)

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (ticketType === "" && ticketValue === "") {
      setTicketTypeError(true);
      // setTicketValueError(true);
    } else if (ticketType === "") {
      setTicketTypeError(true);
    } else if (ticketValue === "") {
      setTicketValueError(true);
    } else if (ticketType !== "lpn" && ticketLPN === "") {
      setTicketLPNError(true);
    } else {
      setLoading(true);

      let count;

      if (ticketType === "lpn") {
        count = lpn + 1;
        setLpn(count);
      } else if (ticketType === "ticket") {
        count = ticket + 1;
        setTicket(count);
      } else if (ticketType === "booking-reference") {
        count = bookingReference + 1;
        setBookingReference(count);
      }

      // localStorage.setItem(ticketType, count);

      await fetch(`${api}/operations/ev/qrvalidation`, {
        method: "POST",
        headers: headers,
        // mode: "cors",
        // credentials: "include",
        // withCredentials: true,
        // crossorigin: true,
        body: JSON.stringify({
          UnitId: unitId,
          Type: ticketType,
          LPN: ticketType === "lpn" ? ticketValue : ticketLPN,
          Value: ticketValue,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "success") {
            setLoading(false);
            setSuccess(true);
            setTicketType("");
            setTicketValue("");
            setTicketLPN("");
          } else if (data.errorMessage != null) {
            setLoading(false);
            setErrorMessageOpen(true);
            setErrorMessageString(data.errorMessage);
            //Check if the retries for all types is exhauseted or not. As we have 3 types we are multiplying by 3
            if (lpn + ticket + bookingReference + 1 == MAX_TRIES * 3) {
              setInactive(true);
              setErrorMessageOpen(false);
              console.log("test-exhausted");
            }
          } else {
            console.log(data);
            setLoading(false);
            setTicketType("");
            setTicketValue("");
            setTicketLPN("");
            setErrorMessageOpen(true);
            setErrorMessageString("Unknown ERROR");
          }
        })
        .catch((err) => {
          setLoading(false);
          setErrorMessageOpen(true);
          setErrorMessageString("Invalid Request");

          //Check if the retries for all types is exhauseted or not. As we have 3 types we are multiplying by 3
          if (lpn + ticket + bookingReference + 1 == MAX_TRIES * 3) {
            setInactive(true);
            setErrorMessageOpen(false);
            console.log("test-exhausted");
          }
        });
    }
  };

  // console.log(qrstatus);

  const IsLocationValidate = ({ children }) => {
    return (
      <Box
        display={"flex"}
        width={"100vw"}
        height={"100vh"}
        textAlign={"center"}
        // bgcolor={"gray"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Box flexDirection={"column"}>
          <Box
            display={"flex"}
            justifyContent={"center"}
            gap={2}
            height={50}
            m={6}
          >
            <img alt="" src={bgImage} height={75} />
          </Box>
          <Typography
            variant="h5"
            fontWeight={"bold"}
            sx={{ color: "#0545af", mb: 1 }}
          >
            {children}
          </Typography>
          <Typography variant="body2">
            Please keep the Location ON. Once you are within the 30-mile radius
            please refresh the page.
          </Typography>
          <Box
            display={"flex"}
            justifyContent={"center"}
            gap={2}
            height={60}
            m={3}
          >
            <img alt="" src={abmlogo} height={40} />
          </Box>
        </Box>
      </Box>
    );
  };

  // Show message while loading

  console.log(envType);
  if (envType === "prod") {
    if (isLocationLoading) {
      return <IsLocationValidate>Checking location access…</IsLocationValidate>;
    }

    if (!longitude && !latitude) {
      return (
        <IsLocationValidate>Turn on your location to access</IsLocationValidate>
      );
    } else if (!withinTheRadius) {
      return (
        <IsLocationValidate>
          You are outside the 30-mile radius.
        </IsLocationValidate>
      );
    }
  }

  if (isLoading) {
    return (
      <Box
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        width={"100vw"}
        height={"100vh"}
      >
        <CircularProgress size="12rem" />
      </Box>
    );
  }
  const deviceHealth = qrstatus?.status_message;
  const unitStatus = qrstatus.current_evse_state?.includes("Ready");

  if (qrstatus.health) {
    if (!deviceHealth || !unitStatus) {
      return (
        <Box
          display={"flex"}
          width={"100vw"}
          height={"100vh"}
          textAlign={"center"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Card
            variant="elevation"
            elevation={24}
            sx={{ width: 350, borderRadius: "15px" }}
          >
            <Box
              width={"100%"}
              height={"120px"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              bgcolor={"#d41616ff"}
            >
              <WarningAmberIcon sx={{ color: "#FFFFFf", fontSize: "80px" }} />
            </Box>
            <CardContent>
              {/* <Typography
                variant="h5"
                fontWeight={"600"}
                // mb={2}
                color={deviceHealth ? "success" : "error"}
              >
                {qrstatus?.current_evse_state.toUpperCase()}!
              </Typography> */}
              {deviceHealth ? (
                <Typography
                  sx={{ textTransform: "uppercase" }}
                  variant="h5"
                  fontWeight={"600"}
                  my={3}
                >
                  Please try another charger.
                </Typography>
              ) : (
                <Typography my={3} sx={{ fontWeight: "600" }}>
                  {qrstatus.status}
                </Typography>
              )}

              {/* <Divider
                variant="middle"
                sx={{ borderColor: "#000000", margin: "5px 0 15px" }}
              />
              <p style={{ fontWeight: "500", margin: 0 }}>
                This charger is currently in use.
              </p> */}
            </CardContent>
          </Card>
        </Box>
      );
    }
  }

  return (
    <RootStyle>
      {success ? (
        <SuccessScreen />
      ) : (
        <>
          <LogoStyle>
            <img alt="" src={bgImage} height={130} />
          </LogoStyle>
          <Container maxWidth="sm">
            {inactive ? (
              <MessageContentStyle>
                <HeadingStyle
                // component={motion.div} {...fadeInUp}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: "text.secondary", mb: 1 }}
                  >
                    {TRIES_EXCEEDED_MSG}
                    {/* {timeDiff} mins. */}
                  </Typography>
                </HeadingStyle>
              </MessageContentStyle>
            ) : (
              <ContentStyle>
                {loading ? (
                  <CircularProgress size="15rem" />
                ) : (
                  <>
                    <HeadingStyle
                    // component={motion.div} {...fadeInUp}
                    >
                      <Typography
                        variant="h3"
                        gutterBottom
                        sx={{ color: "#005baa", mb: 2 }}
                      >
                        Welcome
                      </Typography>
                      <Typography>
                        <strong>You are inside the 30-mile radius.</strong>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary", mb: 1 }}
                      >
                        Please enter the following to get started:
                      </Typography>
                    </HeadingStyle>
                    <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                      <Box
                      // component={motion.div}
                      // animate={{
                      //   transition: {
                      //     staggerChildren: 0.55,
                      //   },
                      // }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 3,
                          }}
                          // component={motion.div}
                          // initial={{ opacity: 0, y: 40 }}
                          // animate={animate}
                        >
                          <FormControl
                            required
                            sx={{ m: 1, minWidth: 80, ...labelStyles }}
                            error={ticketTypeError}
                          >
                            <TextField
                              select
                              InputLabelProps={{
                                shrink: true,
                                sx: {
                                  fontWeight: 600,
                                  color: "black",
                                },
                              }}
                              disabled={errorMessageOpen}
                              labelId="ticketType"
                              id="ticketType"
                              label="Type"
                              required
                              defaultValue=""
                              value={ticketType}
                              onChange={(e) => {
                                setTicketTypeError(false);
                                setTicketType(e.target.value);
                              }}
                              error={ticketTypeError}
                            >
                              {/* <MenuItem disabled={lpn>=MAX_TRIES? true:false} value="lpn">LPN</MenuItem> */}
                              <MenuItem
                                // disabled={ticket >= MAX_TRIES ? true : false}
                                value="ticket"
                              >
                                Ticket
                              </MenuItem>
                              <MenuItem
                                // disabled={
                                //   bookingReference >= MAX_TRIES ? true : false
                                // }
                                value="booking-reference"
                              >
                                Booking Reference
                              </MenuItem>
                              <MenuItem
                                // disabled={
                                //   bookingReference >= MAX_TRIES ? true : false
                                // }
                                value="seasonal"
                              >
                                Employee
                              </MenuItem>
                            </TextField>
                            <FormHelperText>{"Type Required"}</FormHelperText>
                          </FormControl>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 3,
                          }}
                          // component={motion.div}
                          // initial={{ opacity: 0, y: 40 }}
                          // animate={animate}
                        >
                          <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <TextField
                              InputLabelProps={{
                                shrink: true,
                                sx: {
                                  fontWeight: 600,
                                  color: "black",
                                },
                              }}
                              value={ticketValue}
                              disabled={errorMessageOpen}
                              required
                              error={ticketValueError}
                              id="ticketValue"
                              label={
                                (ticketType === "ticket" && "Ticket Number") ||
                                (ticketType === "seasonal" &&
                                  "Seasonal Card ID") ||
                                (ticketType === "booking-reference" &&
                                  "Booking Number")
                              }
                              helperText={
                                (ticketValueError &&
                                  ticketType === "ticket" &&
                                  "Ticket Number Required") ||
                                (ticketValueError &&
                                  ticketType === "seasonal" &&
                                  "Seasonal Card ID Required") ||
                                (ticketValueError &&
                                  ticketType === "booking-reference" &&
                                  "Booking Number Required")
                              }
                              onChange={(e) => {
                                setTicketValueError(false);
                                setTicketValue(e.target.value.trim());
                              }}
                              sx={labelStyles}
                            />
                          </FormControl>
                        </Box>
                        {ticketType === "" || ticketType === "lpn" ? (
                          ""
                        ) : (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 3,
                            }}
                            // component={motion.div}
                            // initial={{ opacity: 0, y: 40 }}
                            // animate={animate}
                          >
                            <FormControl sx={{ m: 1, minWidth: 80 }}>
                              <TextField
                                InputLabelProps={{
                                  shrink: true,
                                  sx: {
                                    fontWeight: 600,
                                    color: "black",
                                  },
                                }}
                                disabled={errorMessageOpen}
                                required
                                value={ticketLPN}
                                error={ticketLPNError}
                                id="LPN"
                                label="License Plate Number"
                                helperText={
                                  ticketLPNError
                                    ? "Please enter License Plate Number."
                                    : "License Plate Number Required"
                                }
                                onChange={(e) => {
                                  setTicketLPNError(false);
                                  setTicketLPN(
                                    e.target.value.toUpperCase().trim()
                                  );
                                }}
                                sx={labelStyles}
                              />
                            </FormControl>
                          </Box>
                        )}

                        <Box
                        // component={motion.div}
                        // initial={{ opacity: 0, y: 20 }}
                        // animate={animate}
                        >
                          <Collapse in={errorMessageOpen}>
                            <Stack sx={{ width: "96.4%", m: 1, minWidth: 80 }}>
                              <Alert
                                severity="error"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={handleErrorMessage}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                                sx={{ mb: 2 }}
                              >
                                <AlertTitle>Error</AlertTitle>
                                {errorMessageString}
                              </Alert>
                            </Stack>
                          </Collapse>
                        </Box>
                        <Box p={1} textAlign={"center"}>
                          <Typography color="warning">
                            ** Please plugin the charger before submit **
                          </Typography>
                        </Box>

                        <Box
                        // component={motion.div}
                        // initial={{ opacity: 0, y: 20 }}
                        // animate={animate}
                        >
                          <LoadingButton
                            disabled={errorMessageOpen}
                            fullWidth
                            size="large"
                            type="submit"
                            variant="contained"
                            loading={isSubmitting}
                            sx={{
                              m: 1,
                              minWidth: 80,
                              width: "96.4%",
                              backgroundColor: "#005baa",
                            }}
                          >
                            {isSubmitting ? "loading..." : "Submit"}
                          </LoadingButton>
                        </Box>
                      </Box>
                    </form>
                  </>
                )}
              </ContentStyle>
            )}
          </Container>
          <LogoStyle>
            <img alt="" src={abmlogo} width={150} />
          </LogoStyle>
        </>
      )}
    </RootStyle>
  );
}

export default App;
